import { LandingPageOption } from '@app/models/enums'
import { ICurrentUserState } from '@app/store/modules/account'
import * as React from 'react'
import { Redirect, RouteComponentProps } from 'react-router-dom'
import { getHashRouteMapping } from './hashRouteMapping'

export interface ILandingPageProps {
  landingPage?: LandingPageOption
  lastPage?: string
}

type LandingPageProps = ILandingPageProps &
  ICurrentUserState &
  RouteComponentProps<{}>

export class LandingPage extends React.PureComponent<LandingPageProps> {
  public render() {
    return <Redirect to={this._getLandingPage()} />
  }

  private _getLandingPage() {
    if (this.props.location.hash) {
      return this._mapHashRoute()
    }

    if (this.props.user && this.props.user.permissions.isGuest) {
      return '/development/clients'
    }

    switch (this.props.landingPage) {
      case LandingPageOption.Assignments:
        return '/assignments'

      case LandingPageOption.Companies:
      case LandingPageOption.Connections:
        return '/connections'

      case LandingPageOption.LastPage:
        return this.props.lastPage || '/home'

      case LandingPageOption.Leads:
        return '/brokerage/leads'

      case LandingPageOption.Listings:
        return '/brokerage/listings'

      case LandingPageOption.Pipeline:
        return '/brokerage/pipeline'

      case LandingPageOption.Properties:
        return '/properties/properties'
      case LandingPageOption.SuccessStories:
        return '/properties/successStories'
      default:
        return '/home'
    }
  }

  private _mapHashRoute() {
    const hashRouteMapping = getHashRouteMapping()

    const queryIndex = this.props.location.hash.indexOf('?')
    const hash =
      queryIndex > 0
        ? this.props.location.hash.substring(0, queryIndex)
        : this.props.location.hash
    const query =
      queryIndex > 0 ? this.props.location.hash.substring(queryIndex) : ''

    for (const map of hashRouteMapping) {
      if (map.oldRoute.test(hash)) {
        return hash.replace(map.oldRoute, map.newRoute) + query
      }
    }

    // No other matches so just return the hash route without the hash
    return hash.replace('#', '') + query
  }
}
